'use strict'

import React from 'react'

function RatingStar (props) {
  return (
    <>
      <input id={`item${props.i}`}
             name="rating"
             type="radio"
             value={props.i}
             onChange={props.onChange}
             className="raiting__check"/>
      <label htmlFor={`item${props.i}`}
             className="raiting__star">
        <i className="ic-big-star"/>
        <span className="rating-name">{props.i}</span>
      </label>
    </>
  )
}

export default RatingStar